import { Component, inject, input } from '@angular/core';
import { NgClass } from '@angular/common';
import { RouterModule } from '@angular/router';
import {
  ExtendedAuthService,
  IsAdminPipe,
  IsExternalPipe,
  IsMonitorPipe,
} from '../../../auth/auth.service';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { MatButtonModule } from '@angular/material/button';
import { ShoppingCartIconComponent } from '../shopping-cart-icon/shopping-cart-icon.component';
import { GhostingComponent } from '../../../auth/ghosting/ghosting.component';
import { toSignal } from '@angular/core/rxjs-interop';
import { environment } from '../../../../../environments/environment';
import { vacationPeriods } from '../../../../api/period/period.util';
import { NavMenuLinkComponent } from './nav-menu-link/nav-menu-link.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  standalone: true,
  imports: [
    NgClass,
    RouterModule,
    CdkAccordionModule,
    MatButtonModule,
    ShoppingCartIconComponent,
    IsMonitorPipe,
    IsExternalPipe,
    IsAdminPipe,
    GhostingComponent,
    NavMenuLinkComponent,
    NavMenuComponent,
  ],
})
export class NavigationComponent {
  public isAtTop = input<boolean>(false);

  opened = false;
  profileText = $localize`Profile`;

  protected readonly auth = inject(ExtendedAuthService);
  protected readonly user = toSignal(this.auth.user$);

  toggleMobileNav() {
    this.opened = !this.opened;
  }

  protected readonly provideAfterSchool = environment.provideAfterSchool;
  protected readonly vacationPeriods = vacationPeriods;
}
